import { sumBy } from 'lodash';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Loader from 'layout/atoms/Loader/Loader';
import TableGrid, { Body, Cell, Footer, Head, Row } from 'layout/atoms/TableGrid';
import Grid from 'layout/molecules/Grid/Grid';
import { fetchPreviewQuantities, selectSpecificationPreviewStatus, } from 'store/specificationPreviewSlice';
function Quantities() {
    var _a;
    const { t } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const storeData = useSelector((state) => state.specificationPreview);
    const status = useSelector(selectSpecificationPreviewStatus);
    useEffect(() => {
        var _a;
        if (status.fetchQuantities === 'idle' && ((_a = storeData.item) === null || _a === void 0 ? void 0 : _a.id)) {
            dispatch(fetchPreviewQuantities({ specificationId: storeData.item.id }));
        }
    }, [dispatch, status.fetchQuantities, (_a = storeData.item) === null || _a === void 0 ? void 0 : _a.id]);
    if (status.fetchQuantities === 'idle' || status.fetchQuantities === 'loading') {
        return React.createElement(Loader, null);
    }
    const sizes = storeData.item.sizes.edges.map((node) => node.node);
    const colors = storeData.item.colors.edges.map((node) => node.node);
    const variants = storeData.item.variants.edges.map((node) => node.node);
    const activeVariants = variants.filter((variant) => variant.isActive);
    const sortVariants = (sizes, variantsRow) => {
        const idOrderMap = new Map();
        sizes.forEach((item, index) => {
            idOrderMap.set(item.id, index);
        });
        return variantsRow.sort((a, b) => {
            var _a, _b;
            const indexA = (_a = idOrderMap.get(a.size.id)) !== null && _a !== void 0 ? _a : Infinity;
            const indexB = (_b = idOrderMap.get(b.size.id)) !== null && _b !== void 0 ? _b : Infinity;
            return indexA - indexB;
        });
    };
    return (React.createElement(Grid, { gap: 12, overflow: true },
        React.createElement(TableGrid, { columns: [
                ['120px', '1fr'],
                ...sizes
                    .filter((size) => size.isActive)
                    .map(() => ['80px', '1fr']),
                ['100px', '1fr'],
            ] },
            React.createElement(Head, null,
                React.createElement(Row, { head: true },
                    React.createElement(Cell, null, t('common:version')),
                    sizes.map((size) => size.isActive && React.createElement(Cell, { key: size.id }, size.sizeName.name)),
                    React.createElement(Cell, null, t('common:summary')))),
            React.createElement(Body, null, colors.map((color) => {
                return (React.createElement(Row, { key: color.id },
                    React.createElement(Cell, null, color.name),
                    sortVariants(sizes, variants.filter((variant) => variant.color.id === color.id)).map((variant) => {
                        return variant.isActive && React.createElement(Cell, { key: variant.id }, variant.quantity);
                    }),
                    React.createElement(Cell, null,
                        sumBy(activeVariants.filter((variant) => variant.color.id === color.id), (item) => Number(item.quantity)),
                        ' ',
                        t('pcs_shortcut'))));
            })),
            React.createElement(Footer, null,
                React.createElement(Row, { foot: true },
                    React.createElement(Cell, null, t('common:summary')),
                    sizes.map((size) => size.isActive && (React.createElement(Cell, { key: size.id },
                        sumBy(activeVariants.filter((variant) => variant.size.id === size.id), (item) => Number(item.quantity)) || 0,
                        ' ',
                        t('pcs_shortcut')))),
                    React.createElement(Cell, null,
                        sumBy(activeVariants, (item) => Number(item.quantity)),
                        " ",
                        t('pcs_shortcut')))))));
}
export default Quantities;
